import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Menu from "./elemets/menu";

import "./../src/css/math.css"
// import "./css/media.css"

// Import components
import Apply from "./components/apply";
import Course from "./components/course";
import Error from "./components/error";
import Home from "./components/home";
import NextError from "./components/nexterror"
import UserApp from "./components/userapp";

// Import Login components
import Login from "./login/login";
import SignUp from "./login/signup";
import SignupVerification from "./login/signupVerification";
import Verification from "./login/verification";
import ForgetPassword from "./login/forgetpassword";

// Import Test components
import Test from "./test/test";
import Exam from "./test/exam";

// Import Profile components
import Dashboard from "./profile/dashboard";
import DeleteAccount from "./profile/deleteAccount";
import Profile from "./profile/profile";
import ShowInvoice from "./profile/showInvoice";
import ShowCourse from "./profile/showCourse";
import ChangePassword from "./profile/changePassword";
import Result from "./profile/result"
import Answersheet from "./profile/answersheet";

// Footer components
import About from "./footer/about";
import Conditions from "./footer/conditions"
import Contact from "./footer/contact";
import Features from "./footer/features";
import FooterBox from "./footer/footerbox";
import Guide from "./footer/guide";
import Guidelines from "./footer/guidelines";
import Help from "./footer/help";
import Manual from "./footer/manual";
import Policy from "./footer/policy"
import Cookies from "./footer/cookies"


const AppContent = () => {
  const location = useLocation()
  const isHome = location.pathname === "/"

  return (
    <>
      {!isHome && <Menu />}
      <Routes>
        {/* Main Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/course" element={<Course />} />
        <Route path="/app" element={<UserApp />} />
        <Route path="/apply" element={<Apply />} />
        
        {/* Login Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signupVerification" element={<SignupVerification />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
        
        {/* Test Routes */}
        <Route path="/test" element={<Test />} />
        <Route path="/exam" element={<Exam />} />

        {/* Profile Nested Routes (FIXED: Removed /* from path) */}
        <Route path="/profile" element={<Profile />}>
          {/* FIXED: Used 'index' for default child route */}
          <Route index element={<Dashboard />} />
          <Route path="result" element={<Result />} />
          <Route path="showCourse" element={<ShowCourse />} />
          <Route path="showInvoice" element={<ShowInvoice />} />
          <Route path="changePassword" element={<ChangePassword />} />
          <Route path="deleteAccount" element={<DeleteAccount />} />
          <Route path="*" element={<NextError />} />
        </Route>
        
        {/* FIXED: Added leading slash for clarity on root level route */}
        <Route path="/answersheet" element={<Answersheet />} />

        {/* Footer Nested Routes (FIXED: Removed /* from path) */}
        <Route path="/footer" element={<FooterBox />}>
          <Route index element={<Navigate to="about" replace />} />
          <Route path="about" element={<About />} />
          <Route path="conditions" element={<Conditions />} />
          <Route path="contact" element={<Contact />} />
          <Route path="features" element={<Features />} />
          <Route path="guide" element={<Guide />} />
          <Route path="guidelines" element={<Guidelines />} />
          <Route path="help" element={<Help />} />
          <Route path="manual" element={<Manual />} />
          <Route path="policy" element={<Policy />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="*" element={<NextError />} />
        </Route>

        {/* Global Error Route */}
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  )
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;